import * as FutureFragment from "@eyeo-fragments/in-product-messaging/background";
import { LicenseState } from "./legacy.types";
function setCommandActor(commandName, actor) {
    FutureFragment.setCommandActor(commandName, actor);
}
export function getFutureFragmentOverrides() {
    return {
        checkLanguage: async () => { },
        defaultLicenseState: LicenseState.inactive,
        doesLicenseStateMatch: async () => true,
        isValidLicenseStateList: () => true,
        setCommandActor,
    };
}
